var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"w-full",attrs:{"primary":"","outline":""},on:{"click":_vm.addMedia}},[_vm._v(" Add Media ")])
}
var staticRenderFns = []

export { render, staticRenderFns }